// Function to handle login modal functionality
function initializeDeleteModal(id) {
  $("#deleteModal #deleteBtn").data("id",id);
  $("#deleteModal").addClass("show");
}

(function() {
  $("#alertModal").on("click", "#alertCancelBtn", function(e){
    e.preventDefault();
    $("#alertModal").removeClass("show");
  });

  $("#deleteModal").on("click", "#deleteBtn", async function(e){
      e.preventDefault();
      console.log("id:" + $(this).data("id"));
      $("#deleteModal").removeClass("show");
      $(".loader-container").addClass("show");
      const response = await fetch("https://dwshopify-bhcta4hacucegahc.eastus-01.azurewebsites.net/dream-conversation-delete.php", {
        method: "POST",
        body: JSON.stringify(
        {
          lang: window.dreamexplorer_listings.lang,
          customer_id: window.dreamexplorer_listings.customer_id,
          conversation_id: $(this).data("id")
        }),
      });

      if (response.ok) 
      {
        const result = await response.json();
        if (result.status) 
        {
          var toRemove = $("#conversation-" + $(this).data("id"));
          toRemove.next('.content').remove();
          toRemove.remove();
          $(".loader-container").removeClass("show");
        } else {
          $(".loader-container").removeClass("show");
          $("#alertModal").addClass("show");
        }
      }
      else{
        $(".loader-container").removeClass("show");
        $("#alertModal").addClass("show");
      }
  });

  $("#deleteModal").on("click", "#deleteCancelBtn", function(e){
      e.preventDefault();
      $("#deleteModal").removeClass("show");
  });

  $("#dreamListings").on("click", ".accordion-btn-delete", function(e){
      e.preventDefault();
      e.stopPropagation();
      initializeDeleteModal($(this).data("id"));
  });
  
  if($("#dreamListings").length > 0){
    try {
        const response = fetch('https://dwshopify-bhcta4hacucegahc.eastus-01.azurewebsites.net/dreams.php', 
        {
          method: "POST",
          body: JSON.stringify({
            customer_id: window.dreamexplorer_listings.customer_id,
            lang: window.dreamexplorer_listings.lang
          })
        });
        response.then(res => {
          return res.json();
        })
        .then(res => {
          if(res.status){
            var results = res.data;

            if(results.length <= 5) {
              setTimeout(() => {
                $('.floating-button').addClass('empty');
                $('.floating-button').addClass('active');
              },0);
            }

            for (let i = 0; i < results.length; i++) {
              var conversation = results[i];
              if(results[i].conversations.length>0)
              {
                $("#dreamListings").append(`<div class="accordion" id="conversation-` + conversation.id + `">
                                                <span>` + conversation.conversations[0].text + `</span>
                                                <a href="javascript:;" data-id="` + conversation.id + `" class="accordion-btn-delete">
                                                    <img src="` + window.dreamexplorer_listings.url_img_delete + `" width="24px" height="auto">
                                                </a>
                                                <div class="accordion-btn">
                                                    <img src="` + window.dreamexplorer_listings.url_img_arrow_down + `" width="24px" height="auto">
                                                </div>
                                            </div>`);
                var content = `<div class="content">`;
                for (let y = 0; y < conversation.conversations.length; y++) {
                  var message = conversation.conversations[y];
                  var d = new Date(message.date);
                  const formattedDate = d.toLocaleDateString(window.dreamexplorer_listings.lang, {
                    weekday: 'long',   // e.g., "Monday"
                    year: 'numeric',   // e.g., "2025"
                    month: 'long',     // e.g., "July"
                    day: 'numeric'     // e.g., "8"
                  });
                  const formattedTime = d.toLocaleTimeString("pt-BR", {
                    hour: '2-digit',
                    minute: '2-digit'
                  });
                  
                  const fullFormatted = `${formattedDate} ${window.dreamexplorer_listings.as} ${formattedTime}`;
                  if(message.is_user)
                    content = content + `<div class="user-dream">` + message.text + `</div>
                                         <div class="user-dream-date">` + fullFormatted + `</div>`;
                  else
                    content = content + `<div class="interpretation">
                                           <div class="interpretation-detail">` + message.text + `</div>
                                         </div>
                                         <div class="interpretation-detail-date">` + fullFormatted + `</div>`;  
                }
                content = content + `</div>`;
                $("#dreamListings").append(content);
                setTimeout(() => {
                    var els = $("#dreamListings .accordion");
                    var h = 0;
                    for(var i=0;i < 5 && i< els.length;i++)
                      h = h + els.eq(i).outerHeight(true);
                    /* $("#dreamListings").css("overflow-y", "auto");
                    $("#dreamListings").height(h); */
                    
                    if($(window).width() > 500){
                      $(window).trigger('scroll');
                    } else {
                      $('.floating-button').addClass('active');
                    }
                },0);
              } 
            }
            
          }
        });
      } catch (error) {
      }

    $("#dreamListings").on("click", ".accordion", function(e){
      e.preventDefault();
      if($(this).hasClass("open"))
      {
        $(this).removeClass("open");
        $(this).next().removeClass("open");
      }
      else{
        $(this).addClass("open");
        $(this).next().addClass("open");
      }
    });

    $(window).scroll(function(){
      if($('.floating-button').hasClass('empty')){
        return;
      }
      if($(this).width() > 500){
        if ($(this).scrollTop() > 200 && !$('.floating-button').hasClass('active')){
          $('.floating-button').addClass('active');
        } else if($(this).scrollTop() <= 200 && $('.floating-button').hasClass('active')) {
          $('.floating-button').removeClass('active');
        }
      }
    });
  }

  
  
  $('#btn-newsletter').on('click', function (e) {
    e.preventDefault();
    $(".error_name").css("display", "none");
    $(".error_server").css("display", "none");
    var customerName = $.trim($("#contact_name").val());
    if(customerName == "")
    {
      $(".error_name").css("display", "block");
    }
    else{
      $('#btn-newsletter').addClass("loading");
      $('#btn-newsletter').attr('disabled','disabled');
      try {
        const response = fetch('https://dwshopify-bhcta4hacucegahc.eastus-01.azurewebsites.net/newsletter.php', 
        {
          method: "POST",
          body: JSON.stringify({
            id: window.dreamexplorer_listings.customer_id,
            name: customerName,
            lang: window.dreamexplorer_listings.lang
          })
        });
        response.then(res => {
          return res.json();
        })
        .then(res => {
          $('#btn-newsletter').removeAttr('disabled');
          $('#btn-newsletter').removeClass("loading");
          if(res.status){
            window.location.href = window.location.href;
          }
          else{
            $(".error_server").css("display", "block");
          }
          
        });
      } catch (error) {
          $('#btn-newsletter').removeAttr('disabled');
          $('#btn-newsletter').removeClass("loading");
          $(".error_server").css("display", "block");
      }
    }
  });
})();